import key from "../config/config";
import * as api from "../routes/userroutefront";
import axios from "../config/axios";

export const submitWireTransferRequest = async (data) => {
  try {
    const respData = await axios({
      url: key.API_URL + api.wireTransferRequest,
      method: "post",
      data,
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
      errors: respData?.data?.errors,
    };
  } catch (err) {
    return {
      status: false,
      message: err?.response?.data?.message || "Could not submit wire request",
      errors: err?.response?.data?.errors,
      httpStatus: err?.response?.status,
    };
  }
};
